const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		// swiper配置
		bannerOption: {
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				waitForTransition: false,
			},
			loop: true,
			effect: 'fade',
			pagination: {
				el: '.swiper-pagination',
			},
		},
		// 专业id(11安全, 13消防)
		mid: null,
		bannerList: [],
		sceneList: [
			{
				url: 'images/scene1.jpg'
			},
			{
				url: 'images/scene2.jpg'
			},
			{
				url: 'images/scene3.jpg'
			},
		],
		classList: [],
		// swiper配置
		liveOption: {
			autoplay: true,
			slidesPerView: 1.5,
		},
		liveList: [],
		newsList: []
	},
	methods: {
		// 咨询
		openWin() {
            this.openServe();
        },
		getParams() {
			this.mid = this.getQueryString('mid') || 11;
			document.querySelector('title').innerText = this.mid == 11 ? '安全工程师-中科建安' : '消防工程师-中科建安';
		},
		// 获取轮播
		getBanner() {
			axios.post(baseURL + 'getIndexImg?mid=' + this.mid)
				.then(res => {
					if (res.code == 200) {
						res.list.forEach(item => {
							if (item.type == 1) {
								this.bannerList.push(item);
							}
						});
					}
				})
				.catch(err => console.log(err));
		},
		// 直播
		getLive() {
			axios.post(baseURL + 'getAnnounce?page=1&rows=4&mid=' + this.mid)
				.then(res => {
					if (res.code == 200) {
						this.liveList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		// 获取课程列表
		getClassList() {
			axios.post(baseURL + 'getallGradeBymid?mid=' + this.mid)
				.then(res => {
					if (res.code == 200) {
						res.list.forEach(item => {
							item.isActive = false;
						});
						res.list[0].isActive = true;
						this.classList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		// 切换课程类型
		changeClassType(type) {
			this.classList.forEach((item) => {
				item.isActive = false;
			});
			type.isActive = true;
		},
		// 跳转详情
		goClassDetail(item) {
			location.href = 'pages/class/detail.html?format=1&type=1&id=' + item.id + '&mid=' + this.mid;
		},
		// 新闻
		getNews() {
			let apiURL = '';
			if (this.mid == 11) {
				apiURL = baseURL + 'getInfomation?type=3&page=1&rows=5&mid=11';
			} else {
				apiURL = baseURL + 'getInfomation?page=1&rows=5&mid=13';
			}
			axios.post(apiURL)
				.then(res => {
					if (res.code == 200) {
						this.newsList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		goNewsDetail(id) {
			location.href = 'pages/news/detail.html?type=3&id=' + id + '&mid=' + this.mid;
		},
	},
	mounted() {
		this.getParams();
		this.getBanner();
		this.getLive();
		this.getClassList();
		this.getNews();
	}
});